export enum EccfCollectionForm {
  CollectorComfirmationForm = "collector-signature",
  DocumentsForm = "documents",
  DonorInformationForm = "donor-information",
  DonorSignatureForm = "donor-signature",
  OverviewForm = "overview",
  SampleVoidForm = "sample-void",
  ShippingMethodForm = "shipping-method",
  SpecimenForm = "specimen-number",
  SummaryForm = "summary",
}

// TODO migrate to FormStatus
export enum EccfFormStatus {
  Complete = "complete",
  Incomplete = "incomplete",
  Invalid = "invalid",
  NotStarted = "not_started",
}

export enum FormStatus {
  Complete = "complete",
  Incomplete = "incomplete",
  Invalid = "invalid",
  NotStarted = "not_started",
}

export enum HairSource {
  Body = "body",
  Head = "head",
  NotAvailable = "not_available",
}

export enum PrimaryIdType {
  DriverLicense = "driver_license",
  SSN = "ssn",
  EmployeeId = "employee_id",
  Other = "other",
}

export enum SampleType {
  Blood = "blood",
  Saliva = "saliva",
  Hair = "hair",
  Breath = "breath",
  Urine = "urine",
  UrineSplitSpecimen = "urine_split_specimen",
  Nail = "nail",
}

export enum ShippingMethod {
  LabCourier = "courier",
  FedEx = "fedex",
  Ups = "ups",
  Usps = "usps",
  Dhl = "dhl",
  Other = "other",
  Na = "",
}

export enum TestReason {
  Cause = "cause",
  Diversion = "diversion",
  FollowUp = "follow_up",
  Other = "other",
  PeriodicMedical = "periodic_medical",
  PostAccident = "post_accident",
  PreEmployment = "pre_employment",
  Promotion = "promotion",
  Random = "random",
  ReasonableSuspicion = "reasonable_suspicion",
  ReturnToDuty = "return_to_duty",
  Transfer = "transfer",
  Unknown = "",
}

export const PRIMARY_ID_TYPE_MAP: { [key: string]: string } = {
  driver_license: "Driver License",
  ssn: "SSN",
  employee_id: "Employee ID",
};

export const SAMPLE_TYPE_MAP: { [key: string]: string } = {
  blood: "Blood",
  saliva: "Saliva",
  hair: "Hair",
  breath: "Breath",
  urine: "Urine",
  urine_split_specimen: "Urine Split Specimen",
  nail: "Nail",
};

const TEST_CLASS_MAP: { [key: string]: string } = {
  drug: "Drug",
};

export const sampleTypes = Object.keys(SAMPLE_TYPE_MAP);

export function sampleTypeToString(sampleType: string) {
  return SAMPLE_TYPE_MAP[sampleType];
}

export const testClasses = Object.keys(TEST_CLASS_MAP);

export function testClassToString(testClass: string) {
  return TEST_CLASS_MAP[testClass];
}

export const NODE_PATHS = {
  ECCF_COLLECTION_CTX_NODE: ["eccf_collection", 0, "eccf_col_ctx"],
  ECCF_COLLECTION_CTX_GROUP_NODE: ["eccf_collection", 0, "eccf_col_ctx_group"],
  OFFICE_VISIT_META_DATA_NODE: ["office_visit_meta_data"],
  ECCF_COLLECTION_ATTEMPT_CTX_GROUP_NODE: [
    "eccf_collection",
    0,
    "eccf_col_ctx_group",
    "attempt_ctx_group",
  ],
  ECCF_COLLECTION_ATTEMPT_CTX_NODE: ["eccf_collection", 0, "eccf_col_ctx_group", "attempt_ctx"],
  ECCF_DOCUMENTS_PRINT_ATTEMPT_GROUP_NODE: [
    "eccf_collection",
    0,
    "eccf_col_ctx_group",
    "document_audit_trail_group",
  ],
  ECCF_DOCUMENTS_PRINT_ATTEMPT_CTX_NODE: [
    "eccf_collection",
    0,
    "eccf_col_ctx_group",
    "doc_audit_trail_ctx",
  ],

  TESTING_VITAL_SIGNS_GROUP_NODE: [
    "certification_wizard",
    "top_level_navigation",
    "testing",
    "testing_sidebar",
    "vitals",
    "pulse",
  ],

  TESTING_BODY_METRICS_VITAL_SIGNS_GROUP_NODE: [
    "certification_wizard",
    "top_level_navigation",
    "testing",
    "testing_sidebar",
    "vitals",
    "body_metrics",
    "group",
    "data",
  ],

  TESTING_BODY_METRICS_BMI_GROUP_NODE: [
    "certification_wizard",
    "top_level_navigation",
    "testing",
    "testing_sidebar",
    "vitals",
    "body_metrics",
    "group",
    "BMI",
  ],

  TESTING_BP_FIRST_GROUP_VITAL_SIGNS_GROUP_NODE: [
    "certification_wizard",
    "top_level_navigation",
    "testing",
    "testing_sidebar",
    "vitals",
    "blood_pressure",
    "first_group",
  ],

  TESTING_BP_SECOND_GROUP_VITAL_SIGNS_GROUP_NODE: [
    "certification_wizard",
    "top_level_navigation",
    "testing",
    "testing_sidebar",
    "vitals",
    "blood_pressure",
    "second_group",
  ],

  TESTING_BP_THIRD_GROUP_VITAL_SIGNS_GROUP_NODE: [
    "certification_wizard",
    "top_level_navigation",
    "testing",
    "testing_sidebar",
    "vitals",
    "blood_pressure",
    "third_group",
  ],

  TESTING_STOP_BANG_REQUIRED_NODE: [
    "certification_wizard",
    "top_level_navigation",
    "testing",
    "testing_sidebar",
    "vitals",
    "stop_bang_vitals_group",
  ],

  TESTING_LABORATORY_NODE: [
    "certification_wizard",
    "top_level_navigation",
    "testing",
    0,
    "laboratory",
    0,
  ],
};

export const TESTING_AUTHORITY_MAP: { [key: string]: string } = {
  hhs: "HHS",
  nrc: "NRC",
  fmcsa: "FMCSA",
  faa: "FAA",
  fra: "FRA",
  fta: "FTA",
  phmsa: "PHMSA",
  uscg: "USCG",
  none: "None",
};

export const TEST_REASONS_MAP: { [key: string]: string } = {
  [TestReason.PreEmployment]: "Pre-Employment",
  [TestReason.ReturnToDuty]: "Return to Duty",
  [TestReason.Promotion]: "Promotion",
  [TestReason.PeriodicMedical]: "Periodic Medical",
  [TestReason.Random]: "Random",
  [TestReason.Diversion]: "Diversion",
  [TestReason.PostAccident]: "Post Accident",
  [TestReason.FollowUp]: "Follow Up",
  [TestReason.Transfer]: "Transfer",
  [TestReason.ReasonableSuspicion]: "Reasonable Suspicion",
  [TestReason.Cause]: "Cause",
  [TestReason.Other]: "Other",
  [TestReason.Unknown]: "Unknown Reason For Test",
};

function generateOptions<T>(data: Record<string, T>): { value: string; label: T }[] {
  return Object.entries(data).map(([value, label]) => ({
    value: value.toString(),
    label,
  }));
}

function sortObject(obj: Record<string, string>) {
  return Object.keys(obj)
    .sort((a, b) => {
      if (a === "") return -1;
      if (b === "") return 1;
      return Number(a) - Number(b);
    })
    .map((k) => ({ value: k, label: obj[k] }));
}

const SPECIFIC_GRAVITIES = {
  0: "1.000",
  1: "1.005",
  2: "1.010",
  3: "1.015",
  4: "1.020",
  5: "1.025",
  6: "1.030",
};

const PROTEINS = {
  0: "negative",
  1: "trace",
  2: "+ (30)",
  3: "++ (100)",
  4: "+++ (300)",
  5: "++++",
};

export const BLOODS = {
  0: "negative",
  1: "trace",
  2: "small",
  3: "moderate",
  4: "large",
};

export const SUGARS: { [key: number]: string } = {
  0: "negative",
  1: "50",
  2: "100",
  3: "250",
  4: "500",
  5: "1000+",
};

export const WHISPER_DISTANCES = {
  "": "",
  0: "0 feet",
  1: "1 foot",
  2: "2 feet",
  3: "3 feet",
  4: "4 feet",
  5: "5 feet",
  6: "6 feet",
  7: "7 feet",
  8: "8 feet",
  9: "9 feet",
  10: "10 feet",
  11: "11 feet",
  12: "12 feet",
  13: "13 feet",
  14: "14 feet",
  15: "15 feet",
  16: "16 feet",
  17: "17 feet",
  18: "18 feet",
  19: "19 feet",
  20: "20 feet",
};

export const AUDIOMETRIC_SCORES = {
  "": "",
  "-15": "-15",
  "-10": "-10",
  "-5": "-5",
  "0": "0",
  "5": "5",
  "10": "10",
  "15": "15",
  "20": "20",
  "25": "25",
  "30": "30",
  "35": "35",
  "40": "40",
  "45": "45",
  "50": "50",
  "55": "55",
  "60": "60",
  "65": "65",
  "70": "70",
  "75": "75",
  "80": "80",
  "85": "85",
  "90": "90",
  "95": "95",
  "100": "100",
};

export const specificGravityOptions = generateOptions(SPECIFIC_GRAVITIES);
export const proteinOptions = generateOptions(PROTEINS);
export const bloodOptions = generateOptions(BLOODS);
export const sugarOptions = generateOptions(SUGARS);
export const whisperOptions = sortObject(WHISPER_DISTANCES);
export const audiometricOptions = sortObject(AUDIOMETRIC_SCORES);
